export default "__VITE_PUBLIC_ASSET__f6ca70e6__"